import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import scrollIntoView from 'scroll-into-view';
import UserAddressForm from './form';
import AddressPicker from './AddressPicker';
import { PrimaryButton } from 'scy/buttons';
import { editAddress, updateAddress } from './actions';
import { trackNow } from 'shared/models/analytic';
import { width100 } from 'scy/utils.mod.scss';
import Subsection from 'components/checkoutPage/form/Subsection';
import AddNewButton from 'components/checkoutPage/form/AddNewButton';

class UserAddresses extends React.Component {
  constructor(props) {
    super(props);

    const userAddressIds = props.addresses.map(a => a.clientId);
    const selectedAddressId =
      props.selectedAddress && props.selectedAddress.clientId;
    const isNewAddress =
      !selectedAddressId || !_.includes(userAddressIds, selectedAddressId);
    this.state = {
      showNewAddressForm: isNewAddress,
      newAddress: isNewAddress ? props.selectedAddress : {}
    };
  }

  componentDidMount() {
    if (this.props.autoScroll) {
      const containerRect = this.container.getBoundingClientRect();
      if (containerRect && containerRect.top < 0)
        scrollIntoView(this.container);
    }
  }

  openNewAddress() {
    this.setState({ showNewAddressForm: true });
    trackNow('Add New Address Clicked');
  }

  closeNewAddress() {
    this.setState({ showNewAddressForm: false });
    trackNow('Add New Address Canceled');
  }

  select(address) {
    this.closeNewAddress();
    return this.props.onSelectionChange(address);
  }

  confirmSelection() {
    return this.props
      .onBeforeSubmit()
      .then(() => this.props.onSelectionSubmit())
      .catch(() => {});
  }

  submitNewAddress(address) {
    this.setState({ newAddress: address });
    return this.props.onNewAddressSubmit(address);
  }

  render() {
    return (
      <div ref={div => (this.container = div)}>
        {this.props.editingAddress ? (
          <UserAddressForm
            address={this.props.editingAddress}
            onBeforeSubmit={() => this.props.onBeforeSubmit()}
            onSubmit={address => this.props.updateAddress(address)}
            onSuccess={address => {
              this.props.editAddress(null);
              return this.props.onUpdateAddressSuccess(address);
            }}
            onCancel={() => this.props.editAddress(null)}
            fieldsContainer={props => (
              <Subsection {...props} heading="Edit Delivery Address" />
            )}
            autoFocus
          />
        ) : (
          <Fragment>
            <AddressPicker
              addresses={this.props.addresses}
              onChange={address => this.select(address)}
              selectedAddress={
                !this.state.showNewAddressForm && this.props.selectedAddress
              }
              edit={address => this.props.editAddress(address)}
            />

            {this.state.showNewAddressForm ? (
              <UserAddressForm
                address={this.state.newAddress}
                onBeforeSubmit={() => this.props.onBeforeSubmit()}
                onSubmit={address => this.submitNewAddress(address)}
                onSuccess={() => this.props.onNewAddressSuccess()}
                onCancel={() => this.closeNewAddress()}
                fieldsContainer={props => (
                  <Subsection heading="New Delivery Address" {...props} />
                )}
                autoFocus={this.props.autoFocus}
              />
            ) : (
              <>
                <AddNewButton
                  onClick={() => this.openNewAddress()}
                  text="Add New Delivery Address"
                />

                <div className="row">
                  <div className="col-xs-12 col-md-5 col-md-offset-7 col-lg-4 col-lg-offset-8">
                    <PrimaryButton
                      type="button"
                      className={width100}
                      onClick={() => this.confirmSelection()}
                    >
                      Continue
                    </PrimaryButton>
                  </div>
                </div>
              </>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

const ConnectedUserAddresses = connect(
  state => ({
    addresses: state.userAddresses.addresses,
    editingAddress: state.userAddresses.editingAddress
  }),
  {
    editAddress,
    updateAddress
  }
)(UserAddresses);

export default ConnectedUserAddresses;
